<template>
  <v-app>
    <custom-notification />
    <v-app-bar app color="primary darken-1" dark>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img src="@/assets/logo.png" alt="Ctrax logo"> </v-img
        ></v-avatar>
      </v-btn>
      <v-toolbar-title>CTRAX</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-navigation-drawer permanent height="auto" floating light color="white">
              <v-list dense rounded>
                <v-list-item
                  v-for="item in items"
                  :key="item.title"
                  link
                  :to="{ name: item.route }"
                  exact
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-col>
          <v-col class="text-center" cols="8">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer color="primary darken-1" class="d-flex justify-center" app>
      <span class="white--text text-center">&copy; 2019 C trax. All Rights reserved</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: 'Register', icon: 'mdi-earth', route: 'client-portal.register' },
        { title: 'My Account', icon: 'mdi-account', route: 'client-portal.login' },
      ],
    };
  },
};
</script>
